// extracted by mini-css-extract-plugin
module.exports = {"title":"form-set_title__JF2fg","content":"form-set_content__TGcwW"};